import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-privacy-policy',
  templateUrl: './new-privacy-policy.component.html',
  styleUrls: ['./new-privacy-policy.component.scss']
})
export class NewPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
